import {
  GridCellEditStopReasons,
  GridCellModes,
  GridCellModesModel,
  GridEventListener,
  GridCallbackDetails,
} from "@mui/x-data-grid-pro"
import { useCallback, useState } from "react"
import { useTableContext } from "../provider"

export const useEditorCell = () => {

  const ctx = useTableContext()
  const [cellModesModel, setCellModesModel] = useState<GridCellModesModel>({})

  const { cellClickHandler } = ctx.props

  const onCellEditStop: GridEventListener<"cellEditStop"> = (params, event, details) => {
    if (!ctx.props.onCellEditStop) return

    if (params.reason === GridCellEditStopReasons.escapeKeyDown) {
      return
    }

    const { value } = ctx.muiGridApiRef.current.state.editRows[params.id][params.field]

    if (params.value === value) {
      return
    }

    ctx.props.onCellEditStop(params, value)
  }

  const onCellEditCommit: GridEventListener<"cellEditCommit"> = (params, event, details) => {
    if (!ctx.props.onCellEditCommit) return
    ctx.props.onCellEditCommit(params, event)
  }

  const onCellClick: GridEventListener<"cellClick"> = (params, event, details) => {

    if (!event || !event.target) return
    const target = event.target as any
    if (target.tagName === "INPUT" || target.type === "checkbox") return

    if (cellClickHandler) cellClickHandler(params, event, details)

    if (params.isEditable) {
      setCellModesModel((prevModel: GridCellModesModel) => getNewGridCellModesModel(prevModel, params))
      return
    }
  }

  const onCellModesModelChange = (cellModesModel: GridCellModesModel, details: GridCallbackDetails) => {
    setCellModesModel(cellModesModel)
  }

  const tableProps = {
    onCellEditStop,
    onCellEditCommit,
    cellModesModel,
    onCellModesModelChange,
    onCellClick,
    experimentalFeatures: { newEditingApi: true }
  }

  return {
    tableProps,
  }
}

const getNewGridCellModesModel = (prevModel: GridCellModesModel, params) => ({
  // Revert the mode of the other cells from other rows
  ...Object
    .keys(prevModel)
    .reduce(
      (newModel, id) => ({
        ...newModel,
        [id]: Object.keys(prevModel[id])
          .reduce(
            (row, field) => ({
              ...row,
              [field]: { mode: GridCellModes.View }
            }),
            {}
          )
      }),
      {}
    ),
  [params.id]: {
    // Revert the mode of other cells in the same row
    ...Object
      .keys(prevModel[params.id] || {})
      .reduce(
        (result, field) => ({
          ...result,
          [field]: { mode: GridCellModes.View }
        }),
        {}
      ),
    [params.field]: { mode: GridCellModes.Edit }
  }
})
